import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

posthog.init('phc_OH2zeewpV9lC735ocJEYPzgsv8jfnjvFLptpOswiJx2', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
